<template>
  <div class="return-goods">
    <div class="return-content">
      <div class="label">当前订单已发货，请选择是否收到货？</div>
      <div class="goods-info">
        <div class="goods">
          <img src="../../assets/air.png" alt="">
          <div class="txt-box">
            <span>纠纷解决但是房价多少积分</span>
            <p><span>单价：￥4444</span>
              <span style="margin-left:40px;">购买数量：4</span>
            </p>
          </div>
        </div>
        <div class="selection-box">
          <div class="tip">是否收到货？</div>
          <div class="btn-box">
            <div class="btn" :class="{active: activeBtn == 1}" @click="handelClick(1)">
              <img src="../../assets/icon/shou.png" alt="">
              <span>已收到货</span>
            </div>
            <div class="btn" :class="{active: activeBtn == 2}" @click="handelClick(2)">
              <img src="../../assets/icon/wei.png" alt="">
              <span>未收到货</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      activeBtn: 0
    }
  },
  created(){

  },
  methods:{
    handelClick(v){
      this.activeBtn = v
      this.$router.push({path: '/personalCenter/submitApplyReturn'})
    }
  }
}
</script>
<style lang="scss" scoped>
.return-goods{
  padding-bottom: 40px;
  font-size: 16px;
}
.return-content{
  width: 1200px;
  margin: 0 auto;
  text-align: left;
  .label{
    background: #fef1dc;
    height: 46px;
    color: #f46e00;
    font-size: 20px;
    font-weight: bold;
    padding-left: 40px;
    line-height: 46px;
    margin-bottom: 20px;
  }
  .goods-info{
    background: #ffffff;
    border-radius: 10px;
    padding: 50px;
    .goods{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      position: relative;
      img{
        width: 90px;
        height: 90px;
      }
      .txt-box{
        margin-left: 20px;
        p{
          position: absolute;
          bottom: 0;
        }
      }
    }
    .selection-box{
      .tip{
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        margin: 20px 0;
      }
      .btn-box{
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        .btn{
          margin-right: 50px;
          cursor: pointer;
          border: 3px solid #f4f4f4;
          border-radius: 10px;
          width: 400px;
          height: 156px;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 44px;
            height: 44px;
          }
          span{
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            margin-left: 10px;
          }
        }
        .active{
          border: 3px solid #f40000;
        }
      }
    }
  }
}
</style>